export const getTeaseAlerts = state => state.tease.alerts;